import { Box } from '@mui/material';
import Divider from '@mui/material/Divider';

import LayoutOptions from './layout-options';
import Operations from './operations';
import Tooling from './tooling';
import UndoCountoringButtons from './undo-countoring-buttons';

export default function ViewerToolbar() {
    return (
        <Box display="flex">
            <Tooling />
            <Divider flexItem orientation="vertical" sx={{ mx: 2, my: 1 }} />
            <Operations />
            <Divider flexItem orientation="vertical" sx={{ mx: 2, my: 1 }} />
            <UndoCountoringButtons />
            <Divider flexItem orientation="vertical" sx={{ mx: 2, my: 1 }} />
            <LayoutOptions />
        </Box>
    );
}
